<div class="auction-storagetreasure">
  <div class="imageCategory-container">
    <div class="left-Section">
      <div class="preview-container">
        @for (img of previewImages; track img; let i = $index) {
          <div class="preview-box">
            <img [src]="img" class="previewImg" />
            <img src="../../../assets/images/RedMinusSign.svg" class="deleteIcon" (click)="removeImage(i)" />
          </div>
        }

        <label for="file_path" class="upload-label">
          <img src="../../../assets/images/Image_Icon.svg" alt="Upload Photo" id="photoPreview" class="icon-Image"
            style="background-color: rgb(192, 190, 190);"/>
          </label>

          <input type="file" name="file_path" id="file_path" style="display: none;"
            accept="image/png, image/jpg, image/jpeg, image/gif, image/bmp, image/webp" (change)="onFileSelected($event)" />
          </div>
          <div>@if (imageSizeExceeded) {
            <span class="alert-danger imageValidation" style="width: auto">Selected Image
            should be less than 10MB</span>
          }</div>
          <div class="mb-2 publishCheckbox">
            <label class="pure-material-checkbox">
              <input
                type="checkbox"
                [checked]="publishAdvertisement"
                (change)="onPublishAdvertisementChange($event)"
                />
                <span></span>
                <b>Publish Advertisement</b>
              </label>
            </div>
          </div>

          <div class="col-md-6 mb-3 auctionCategory">
            <div class="scroll_outer">
              <div class="scroll_inner">
                <div class="table_withfilter p-0 border-0">
                  <table class="table bg-white table-striped  fixed_headers mb-0">
                    <colgroup>
                    <col width="10%">
                    <col width="90%">
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        <label class="pure-material-checkbox float-start mt-0">
                          <input type="checkbox" class="checkBoxClass" [checked]="allSelected"
                            (change)="selectAllAuctionCategories($event)">
                            <span></span>
                          </label>
                        </th>
                        <th class="text-start">Auction Category</th>
                      </tr>
                    </thead>
                  </table>
                  <div class="table_withfilter" style="overflow-y: auto;max-height: 114px;">
                    <table class="table table-striped text-center mb-0 bg-white table_unsigned table-overflow">
                      <colgroup>
                      <col width="10%">
                      <col width="90%">
                    </colgroup>
                    <tbody>
                      @for (item of auctionCategories; track item) {
                        <tr>
                          <td>
                            <label class="pure-material-checkbox float-start mt-0">
                              <input type="checkbox" class="checkBoxClass"
                                [checked]="isCategorySelected(item)"
                                (change)="selectAuctionCategories(item,$event)">
                                <span></span>
                              </label>
                            </td>
                            <td class="text-start">{{item.CategoryName}}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (!isPrintModule) {
          <div class="col-md-12 col-sm-12 mt-3 float-start goodsStored" >
            <label>Goods / Lien Items Stored <span class="required">*</span></label>
            <textarea rows="3" class="form-control" [value]="unitContents" (input)="onUnitContentsChange($event)"></textarea>
          </div>
        }
        @if (unitContentsTouched && unitContentsError) {
          <div class="alert alert-danger">
            <span>
              Goods/Lien item Stored is required.
            </span>
          </div>
        }
      </div>